import Cookies from 'js-cookie';
const SITE_NAME = window.siteConfig().siteName;
const NAME = `${SITE_NAME}_last-products`;
let LAST_PRODUCTS = JSON.parse(Cookies.get(NAME) || '[]');

const LastProductCookie = {
    add: (slug, variant) => {
        const oldCookieValues = Cookies.get(NAME);
        const lastSeen = oldCookieValues ? JSON.parse(oldCookieValues) : [];
        // newCookieValues[slug] = variant;

        const newProduct = { slug, ...variant };
        const index = lastSeen.findIndex(product => product.slug === slug);
        if (index > -1) {
            //replace
            lastSeen[index] = newProduct;
        } else {
            lastSeen.unshift(newProduct);
        }
        Cookies.set(NAME, JSON.stringify(lastSeen.slice(0, 6)), {
            expires: 365,
            path: window.siteConfig()?.contextPath || '/',
        });
        LAST_PRODUCTS = JSON.parse(Cookies.get(NAME) || null);
    },
    get: slug => {
        if (!slug) return LAST_PRODUCTS;
        return LAST_PRODUCTS.find(variant => variant.slug === slug);
    },
    /**
     * Compare LAST_PRODUCTS with @param products, to detected missing product slugs in API response
     * and removes those from the cookie.
     * Overwrites the old LAST_PRODUCT list the new on in the cookie.
     * */
    removeMissingProductSlugFromCookie: products => {
        LAST_PRODUCTS = LAST_PRODUCTS.filter(lastProduct =>
            products.find(product => product.productGroupSlug === lastProduct.slug)
        );
        Cookies.set(NAME, JSON.stringify(LAST_PRODUCTS), {
            expires: 365,
            path: window.siteConfig()?.contextPath || '/',
        });
    },
};

export default LastProductCookie;
